var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "increase-up-profit 1",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.296847 8.30749C-0.0928011 8.68668 -0.10159 9.31132 0.277804 9.70226C0.655734 10.0932 1.27829 10.102 1.66794 9.72137L5.71823 5.75605L9.10495 9.03501C9.49607 9.41273 10.1186 9.40097 10.4951 9.00855L16.0278 3.39127V6.22343C16.0278 6.77016 16.4687 7.21255 17.0136 7.21255C17.5586 7.21255 17.9995 6.77016 17.9995 6.22343V0.986799H17.9966C17.9966 0.731067 17.8984 0.476805 17.7036 0.284271C17.497 0.0799798 17.2217 -0.0140826 16.9521 0.00355412H12.0698C11.5249 0.00355412 11.084 0.445941 11.084 0.992678C11.084 1.53942 11.5249 1.9818 12.0698 1.9818H14.6523L9.76999 6.93771L6.39646 3.67052C6.0156 3.30308 5.41062 3.30161 5.02976 3.67492L0.296847 8.30749Z",
    fill: "#8BD4D6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit);
export default __webpack_public_path__ + "static/media/profit.2983867e.svg";
export { ForwardRef as ReactComponent };